import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import OneSignal from 'onesignal-cordova-plugin';
import { DataService } from './data.service';
import { ModalMakerService } from './modal-maker.service';
import { environment } from '../../environments/environment';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { GetTranslationService } from './get-translation.service';
@Injectable({
  providedIn: 'root',
})
export class OneSignalService {
  oneSignalId: string;
  inappbrowserUrl: string;
  constructor(
    private http: HttpClient,
    private router: Router,
    private modalServ: ModalMakerService,
    private dataServ: DataService,
    private inappBr: InAppBrowser,
    private translator: GetTranslationService
  ) {}

  oneSignalLogin(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.oneSignalId = localStorage.getItem('oneSignal') || '';

      if (!this.oneSignalId || this.oneSignalId === 'null') {
        reject();
      }

      this.http
        .post(environment.apiURL + '/onesignal_login/' + this.oneSignalId, {
          observe: 'body',
          responseType: 'json',
        })
        .subscribe({
          next: () => resolve(true),
          error: (err) => {
            reject(err);
          },
        });
    });
  }

  async webpush() {
    if (!this.dataServ.rData) {
      await this.dataServ.getRichData();
      await this.dataServ.removeDateRange(this.dataServ.baseData);
    }

    // eslint-disable-next-line @typescript-eslint/dot-notation
    const ONESIGNAL = window['OneSignal'] || [];

    ONESIGNAL.push(() => {
      ONESIGNAL.init({
        appId: this.dataServ.rData.one_signal_app_id,
        autoRegister: true,
        allowLocalhostAsSecureOrigin: true,
        notifyButton: {
          enable: false,
        },
      });
    });

    ONESIGNAL.push(() => {
      ONESIGNAL.push(['registerForPushNotifications']);
    });

    ONESIGNAL.push(() => {
      // Occurs when the user's subscription changes to a new value.
      ONESIGNAL.on('subscriptionChange', (isSubscribed) => {
        ONESIGNAL.getUserId().then((userId) => {
          localStorage.setItem('oneSignal', userId);
          if (isSubscribed && localStorage.getItem('islogged')) {
            this.oneSignalLogin();
          } else {
            this.oneSignalLogout();
          }
        });
      });

      ONESIGNAL.on('notificationDisplay', (event) => {
        if (event) {
          this.notificationEvent(event.data);
        }
      });
    });
  }

  async cordovapush() {
    if (!this.dataServ.rData) {
      await this.dataServ.getRichData();
      await this.dataServ.removeDateRange(this.dataServ.baseData);
    }

    OneSignal.setAppId(this.dataServ.rData.one_signal_app_id); //ID SETLENDİ

    OneSignal.promptForPushNotificationsWithUserResponse((response) => {
      if (response) {
        OneSignal.addSubscriptionObserver((event) => {
          localStorage.setItem('oneSignal', event.to.userId);
        });
      }
    });

    OneSignal.setNotificationOpenedHandler((openedEvent) => {
      this.notificationEvent(openedEvent.notification.additionalData);
    });

    OneSignal.promptLocation();
  }

  async notificationEvent(event: any) {
    const DATA = event.data || event;

    let notificationURL = DATA.url || '';

    switch (DATA.type) {
      case 'survey':
        this.modalServ.survey(DATA, 'notification');
        break;

      case 'RequestMessage':
        this.modalServ.openChat(DATA, false);
        break;

      case 'notification':
        if (notificationURL) {
          // notificationURL varsa, sub_domain_name + guestservice.app içeriyor mu diye kontrol ediyoruz
          if (
            notificationURL.includes(
              `${this.dataServ.rData.sub_domain_name}.guestservice.app`
            )
          ) {
            // Eğer içeriyorsa, router ile yönlendiriyoruz
            this.router.navigateByUrl(notificationURL.split('.app').pop());
          } else {
            // Eğer bu link değilse ve başka bir geçerli URL varsa, InAppBrowser ile açıyoruz
            const COLOR = document.documentElement.style.getPropertyValue(
              '--ion-color-primary'
            );
            const CLOSE = await this.translator.getTranslate('Back');
            this.inappBr.create(notificationURL, '_blank', {
              clearcache: 'yes',
              location: 'yes',
              fullscreen: 'yes',
              enableViewportScale: 'yes',
              toolbar: 'yes',
              closebuttoncolor: '#FFFFFF',
              closebuttoncaption: CLOSE,
              presentationstyle: 'fullscreen',
              transitionstyle: 'crossdissolve',
              toolbartranslucent: 'no',
              toolbarposition: 'top',
              toolbarcolor: COLOR,
              hideurlbar: 'yes',
            });
          }
        } else {
          // Eğer notificationURL yoksa, bildirim modali açıyoruz
          this.modalServ.openNotification(DATA);
        }
        break;

      case 'HotSupport':
        this.modalServ.openChat(DATA, true);
        break;

      case 'Link':
        if (notificationURL) {
          this.router.navigateByUrl(notificationURL);
        } else {
          const sectionID = DATA.menu_section_id;
          const itemID = DATA.menu_item_id;
          this.router.navigateByUrl('/home/' + sectionID + '/' + itemID);
        }
    }
  }

  oneSignalLogout() {
    if (this.oneSignalId === undefined) {
      return;
    }

    this.http
      .post(environment.apiURL + '/onesignal_logout/' + this.oneSignalId, {
        observe: 'body',
        responseType: 'json',
      })
      .subscribe();
  }
}
